import React, { useState } from 'react';
import '../styles/footer.css';
import PrivacyPolicy from "./PrivacyPolicy";
import TermsConditions from "./T&Cs";
import Subprocessors from "./SubProcessors";
import CookiePolicy from "./CookiePolicy";

const Footer = () => {
    const currentYear = new Date().getFullYear();
    const [email, setEmail] = useState('');
    const [subscribed, setSubscribed] = useState(false);
    const [emailError, setEmailError] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [showPrivacy, setShowPrivacy] = useState(false);
    const [showTerms, setShowTerms] = useState(false);
    const [showProcessors, setShowProcessors] = useState(false);
    const [showCookies, setShowCookies] = useState(false);

    const handleEmailChange = (e) => {
        setEmail(e.target.value);
        if (emailError) setEmailError('');
    };

    const validateEmail = (email) => {
        const re = /\S+@\S+\.\S+/;
        return re.test(email);
    };

    const handleSubscribe = async (e) => {
        e.preventDefault();

        if (!email.trim()) {
            setEmailError('Email is required');
            return;
        }

        if (!validateEmail(email)) {
            setEmailError('Please enter a valid email address');
            return;
        }

        setIsSubmitting(true);

        try {
            // Simulate API call
            await new Promise(resolve => setTimeout(resolve, 1000));

            // Success
            setSubscribed(true);
            setEmail('');
        } catch (error) {
            setEmailError('Failed to subscribe. Please try again.');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <footer id='footer' className="footer">
            <div className="footer-top">
                <div className="footer-container">
                    <div className="footer-column company-info">
                        <div className="footer-logo">
                            <span className="logo-text">Intellommerce</span>
                        </div>
                        <p className="company-description">
                            Revolutionizing digital marketing with AI-powered automation that delivers measurable
                            results for businesses of all sizes.
                        </p>
                        <div className="footer-social">
                            <a href="https://www.linkedin.com/company/intellommerce/" aria-label="LinkedIn"
                               className="social-icon-link">
                                <svg className="social-icon" viewBox="0 0 24 24">
                                    <path
                                        d="M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14m-.5 15.5v-5.3a3.26 3.26 0 0 0-3.26-3.26c-.85 0-1.84.52-2.32 1.3v-1.11h-2.79v8.37h2.79v-4.93c0-.77.62-1.4 1.39-1.4a1.4 1.4 0 0 1 1.4 1.4v4.93h2.79M6.88 8.56a1.68 1.68 0 0 0 1.68-1.68c0-.93-.75-1.69-1.68-1.69a1.69 1.69 0 0 0-1.69 1.69c0 .93.76 1.68 1.69 1.68m1.39 9.94v-8.37H5.5v8.37h2.77z"></path>
                                </svg>
                            </a>
                            <a href="#" aria-label="Twitter" className="social-icon-link">
                                <svg className="social-icon" viewBox="0 0 24 24">
                                    <path
                                        d="M22.46 6c-.77.35-1.6.58-2.46.69.88-.53 1.56-1.37 1.88-2.38-.83.5-1.75.85-2.72 1.05C18.37 4.5 17.26 4 16 4c-2.35 0-4.27 1.92-4.27 4.29 0 .34.04.67.11.98C8.28 9.09 5.11 7.38 3 4.79c-.37.63-.58 1.37-.58 2.15 0 1.49.75 2.81 1.91 3.56-.71 0-1.37-.2-1.95-.5v.03c0 2.08 1.48 3.82 3.44 4.21a4.22 4.22 0 0 1-1.93.07 4.28 4.28 0 0 0 4 2.98 8.521 8.521 0 0 1-5.33 1.84c-.34 0-.68-.02-1.02-.06C3.44 20.29 5.7 21 8.12 21 16 21 20.33 14.46 20.33 8.79c0-.19 0-.37-.01-.56.84-.6 1.56-1.36 2.14-2.23z"></path>
                                </svg>
                            </a>
                            <a href="#" aria-label="Facebook" className="social-icon-link">
                                <svg className="social-icon" viewBox="0 0 24 24">
                                    <path
                                        d="M12 2.04c-5.5 0-10 4.49-10 10.02 0 5 3.66 9.15 8.44 9.9v-7H7.9v-2.9h2.54V9.85c0-2.51 1.49-3.89 3.78-3.89 1.09 0 2.23.19 2.23.19v2.47h-1.26c-1.24 0-1.63.77-1.63 1.56v1.88h2.78l-.45 2.9h-2.33v7a10 10 0 0 0 8.44-9.9c0-5.53-4.5-10.02-10-10.02z"></path>
                                </svg>
                            </a>
                            <a href="#" aria-label="Instagram" className="social-icon-link">
                                <svg className="social-icon" viewBox="0 0 24 24">
                                    <path
                                        d="M7.8 2h8.4C19.4 2 22 4.6 22 7.8v8.4a5.8 5.8 0 0 1-5.8 5.8H7.8C4.6 22 2 19.4 2 16.2V7.8A5.8 5.8 0 0 1 7.8 2m-.2 2A3.6 3.6 0 0 0 4 7.6v8.8C4 18.39 5.61 20 7.6 20h8.8a3.6 3.6 0 0 0 3.6-3.6V7.6C20 5.61 18.39 4 16.4 4H7.6m9.65 1.5a1.25 1.25 0 0 1 1.25 1.25A1.25 1.25 0 0 1 17.25 8 1.25 1.25 0 0 1 16 6.75a1.25 1.25 0 0 1 1.25-1.25M12 7a5 5 0 0 1 5 5 5 5 0 0 1-5 5 5 5 0 0 1-5-5 5 5 0 0 1 5-5m0 2a3 3 0 0 0-3 3 3 3 0 0 0 3 3 3 3 0 0 0 3-3 3 3 0 0 0-3-3z"></path>
                                </svg>
                            </a>
                        </div>

                        {/* <div className="footer-awards">
                            <div className="award-badge">
                                <img src="/assets/images/award-innovation.svg" alt="Innovation Award" />
                                <span>AI Innovation Award 2023</span>
                            </div>
                            <div className="award-badge">
                                <img src="/assets/images/award-growth.svg" alt="Growth Award" />
                                <span>Fastest Growing MarTech 2023</span>
                            </div>
                        </div> */}
                    </div>

                    <div className="footer-column">
                        <h3 className="footer-heading">Services</h3>
                        <ul className="footer-links">
                            <li><a onClick={() => {
                                document.getElementById('website').scrollIntoView({behavior: 'smooth'})
                            }}>Web Design & Development</a></li>
                            <li><a onClick={() => {
                                document.getElementById('content').scrollIntoView({behavior: 'smooth'})
                            }}>Automated Content Creation</a></li>
                            <li><a onClick={() => {
                                document.getElementById('campaign').scrollIntoView({behavior: 'smooth'})
                            }}>Smart Campaign Management</a></li>
                            <li><a onClick={() => {
                                document.getElementById('content').scrollIntoView({behavior: 'smooth'})
                            }}>Social Media Automation</a></li>
                            <li><a onClick={() => {
                                document.getElementById('unified').scrollIntoView({behavior: 'smooth'})
                            }}>Email Marketing</a></li>
                            <li><a onClick={() => {
                                document.getElementById('seo').scrollIntoView({behavior: 'smooth'})
                            }}>SEO Optimization</a></li>
                        </ul>
                    </div>

                    <div className="footer-column">
                        <h3 className="footer-heading"></h3>
                        <ul className="footer-links">
                            <li><a href="#"></a></li>
                            <li><a href="#"></a></li>
                            <li><a href="#"></a></li>
                            <li><a href="#"></a></li>
                            <li><a href="#"></a></li>
                            <li><a href="#"></a></li>
                        </ul>
                    </div>

                    <div className="footer-column">
                        <h3 className="footer-heading">Company</h3>
                        <ul className="footer-links">
                            <li><a href="#hero">About Us</a></li>
                            <li><a href="#features">Our Team</a></li>
                            <li><a href="#pricing">Prices</a></li>
                            <li><a href="#contact-form">Contact</a></li>
                        </ul>
                    </div>

                    <div className="footer-column newsletter-column">
                        <h3 className="footer-heading">Stay Updated</h3>
                        {subscribed ? (
                            <div className="subscription-success">
                                <div className="success-icon">
                                    <svg viewBox="0 0 24 24" width="24" height="24">
                                        <path fill="currentColor"
                                              d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
                                    </svg>
                                </div>
                                <p>Thank you for subscribing to our newsletter!</p>
                                <button
                                    className="text-button"
                                    onClick={() => setSubscribed(false)}
                                >
                                    Subscribe another email
                                </button>
                            </div>
                        ) : (
                            <>
                                <p className="newsletter-text">
                                    Subscribe to our newsletter for the latest updates on AI marketing trends and
                                    exclusive insights.
                                </p>
                                <form className="newsletter-form" onSubmit={handleSubscribe}>
                                    <div className="newsletter-input-group">
                                        <input
                                            type="email"
                                            placeholder="Your email address"
                                            className={`newsletter-input ${emailError ? 'error' : ''}`}
                                            value={email}
                                            onChange={handleEmailChange}
                                            disabled={isSubmitting}
                                        />
                                        <button
                                            type="submit"
                                            className="newsletter-button"
                                            disabled={isSubmitting}
                                        >
                                            {isSubmitting ? (
                                                <span className="spinner small-spinner"></span>
                                            ) : (
                                                <svg viewBox="0 0 24 24" width="18" height="18">
                                                    <path fill="currentColor"
                                                          d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"/>
                                                </svg>
                                            )}
                                        </button>
                                    </div>
                                    {emailError && <p className="newsletter-error">{emailError}</p>}
                                </form>
                                <p className="newsletter-disclaimer">
                                    We respect your privacy. Unsubscribe at any time.
                                </p>
                            </>
                        )}

                        <div className="app-badges">
                            <h4>Download Our App</h4>
                            <div className="app-links">
                                <a href="#" className="app-badge app-store">
                                    <svg className="app-icon" viewBox="0 0 24 24">
                                        <path
                                            d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.53 4.08zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z"/>
                                    </svg>
                                    <div className="app-text">
                                        <span className="app-small">Download on the</span>
                                        <span className="app-large">App Store</span>
                                    </div>
                                </a>
                                <a href="#" className="app-badge google-play">
                                    <svg className="app-icon" viewBox="0 0 24 24">
                                        <path
                                            d="M3.609 1.814L13.792 12 3.609 22.186c-.181-.181-.301-.434-.301-.721V2.534c0-.286.12-.539.301-.72zm10.831 10.309l2.116-2.133 5.367 3.092c.827.48.827 1.588 0 2.069l-5.367 3.092-2.116-2.136 3.855-1.993-3.855-1.991zm-.125-1.094L12.404 12l1.911.971L16.203 12l-1.888-.971zm-11.087 11.87l7.635-7.636-7.635-7.636v15.272z"/>
                                    </svg>
                                    <div className="app-text">
                                        <span className="app-small">GET IT ON</span>
                                        <span className="app-large">Google Play</span>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/*   <div className="footer-middle">
                <div className="footer-container">
                    <div className="footer-partners">
                        <h4>Trusted By Industry Leaders</h4>
                        <div className="partner-logos">
                            <img src="/assets/images/partner-logo-1.svg" alt="Partner 1" />
                            <img src="/assets/images/partner-logo-2.svg" alt="Partner 2" />
                            <img src="/assets/images/partner-logo-3.svg" alt="Partner 3" />
                            <img src="/assets/images/partner-logo-4.svg" alt="Partner 4" />
                            <img src="/assets/images/partner-logo-5.svg" alt="Partner 5" />
                        </div>
                    </div>
                </div>
            </div> */
            }

            <div className="footer-bottom">
                <div className="footer-container">
                    <div className="copyright">
                        &copy; {currentYear} <a href="https://intellommerce.ai"><strong>Intellommerce</strong></a>. All
                        rights reserved.
                    </div>
                    <div className="legal-links">
                        <a href="#" onClick={() => setShowPrivacy(true)}>Privacy Policy</a>
                        <span className="divider">|</span>
                        <a href="#" onClick={() => setShowTerms(true)}>Terms of Service</a>
                        <span className="divider">|</span>
                        <a href="#" onClick={() => setShowCookies(true)}>Cookie Policy</a>
                        <span className="divider">|</span>
                        <a href="#" onClick={() => setShowProcessors(true)}>Subprocessors</a>
                        <span className="divider">|</span>
                        <a href="#">Sitemap</a>
                    </div>
                </div>
            </div>

            {showPrivacy && <PrivacyPolicy onClose={() => setShowPrivacy(false)} />}
            {showTerms && <TermsConditions onClose={() => setShowTerms(false)} />}
            {showProcessors && <Subprocessors onClose={() => setShowProcessors(false)} />}
            {showCookies && <CookiePolicy onClose={() => setShowCookies(false)} />}

            <button
                className="scroll-to-top"
                onClick={() => window.scrollTo({top: 0, behavior: 'smooth'})}
                aria-label="Scroll to top"
            >
                <svg viewBox="0 0 24 24" width="24" height="24">
                    <path fill="currentColor" d="M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z"/>
                </svg>
            </button>
        </footer>
    );
};

export default Footer;